module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-Quote-lewis.a548b8d.png";